module.exports = __webpack_public_path__ + "0a8ee4d0a5de0d1cfb05c08fe905162e.png";